/**
 * Custom Modernizr build based on the configurations set in .modernizrrc
 */
require('Modernizr');
var slugify = require('slugify');

/**
 * AOS
 */

import AOS from 'aos';
import 'aos/dist/aos.css';
AOS.init({
    // Global settings:
    disable: false, // accepts following values: 'phone', 'tablet', 'mobile', boolean, expression or function
    startEvent: 'DOMContentLoaded', // name of the event dispatched on the document, that AOS should initialize on
    initClassName: 'aos-init', // class applied after initialization
    animatedClassName: 'aos-animate', // class applied on animation
    useClassNames: false, // if true, will add content of `data-aos` as classes on scroll
    disableMutationObserver: false, // disables automatic mutations' detections (advanced)
    debounceDelay: 50, // the delay on debounce used while resizing window (advanced)
    throttleDelay: 99, // the delay on throttle used while scrolling the page (advanced)

    // Settings that can be overridden on per-element basis, by `data-aos-*` attributes:
    offset: 120, // offset (in px) from the original trigger point
    delay: 0, // values from 0 to 3000, with step 50ms
    duration: 400, // values from 0 to 3000, with step 50ms
    easing: 'ease', // default easing for AOS animations
    once: true, // whether animation should happen only once - while scrolling down
    mirror: false, // whether elements should animate out while scrolling past them
    anchorPlacement: 'top-bottom', // defines which position of the element regarding to window should trigger the animation
});

/**
 * Lazysizes
 */

import 'lazysizes/plugins/unveilhooks/ls.unveilhooks';
import 'lazysizes/plugins/attrchange/ls.attrchange';
import 'lazysizes';

/**
 * CSS variables IE fix
 */

import cssVars from 'css-vars-ponyfill';

/**
 * Object fit IE fix
 */

var objectFitImages = require('object-fit-images');

objectFitImages();

/**
 * Axios
 */

window.axios = require('axios');
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
window.axios.interceptors.response.use(
    function (response) {
        let gaEvent = {
            event: 'axiosRequest',
            attributes: {
                type: response.config.method || '',
                url: response.config.url || '',
                queryParameters: response.config.data || '{}',
                statusCode: response.status || '',
                statusText: response.statusText || '',
                status: 'post_failed',
                headers: response.headers,
                data: response.data || '{}',
            },
        };
        if (response && response.config.method === 'post' && response.data && response.data.success && response.data.form_type) {
            gaEvent.attributes.status = `post_success_${response.data.form_type}`;
            dataLayer.push(gaEvent);
        }

        return response;
    },
    function (error) {
        return Promise.reject(error);
    },
);

/**
 * Resize me script
 */

const resizeElements = document.getElementsByClassName('resize-me');

function resizeMe(resizeElements) {
    if (resizeElements.length > 0) {
        for (var i = 0; i < resizeElements.length; i++) {
            var resizeMe = resizeElements[i];
            var resizeSources = resizeMe.getElementsByClassName('resize-source');
            if (resizeSources.length > 0) {
                var resizeSource = resizeSources[0];
                resizeMe.setAttribute('style', `min-height: ${resizeSource.clientHeight}px`);
            }
        }
    }
}

/**
 * Scroll into view
 */

var scrollIntoView = require('scroll-into-view');

// catch hash for later smooth scrolling
var windowhash = window.location.hash;

// remove url parameters from hash
if (windowhash) {
    windowhash = windowhash.split('?')[0];
}

// disable default hash jump behaviour
if (windowhash) {
    setTimeout(function () {
        window.scrollTo(0, 0);
    }, 1);
}

function scrollToPossibleHash(hash) {
    var originalhash = hash;
    var hash = hash.replace('#', '');

    var section = document.getElementById(hash);

    if (!section) {
        var slug = slugify(decodeURI(hash), { lower: true });
        section = document.getElementById(slug);
    }

    // get the offset of the header
    var header = document.querySelector('header');
    var headerOffset = header.offsetHeight;

    scrollIntoView(section, { align: { top: 0, topOffset: headerOffset + 40 } });

    if (history.pushState) {
        history.pushState(null, null, originalhash);
    } else {
        location.hash = originalhash;
    }
}

/**
 * Vue
 */

window.Vue = require('vue');
import SvgVue from 'svg-vue';

/**
 * Ziggy
 */

import route from 'ziggy';
import { Ziggy } from './ziggy';

Vue.mixin({
    methods: {
        route: (name, params, absolute) => route(name, params, absolute, Ziggy),
    },
});

/**
 * Vee Validate
 */

import { ValidationProvider, ValidationObserver, extend, setInteractionMode } from 'vee-validate';
import * as rules from 'vee-validate/dist/rules';
import nl from 'vee-validate/dist/locale/nl.json';

for (let rule in rules) {
    extend(rule, {
        ...rules[rule],
        message: nl.messages[rule],
    });
}

setInteractionMode('eager');

Vue.component('ValidationProvider', ValidationProvider);
Vue.component('ValidationObserver', ValidationObserver);

/**
 * vue-js-modal
 */

import VModal from 'vue-js-modal';
Vue.use(VModal, { dynamic: true, dynamicDefaults: { clickToClose: true } });

import { VueReCaptcha } from 'vue-recaptcha-v3';

// For more options see below
Vue.use(VueReCaptcha, {
    siteKey: process.env.MIX_RECAPTCHA_SITE_KEY,
    loaderOptions: {
        autoHideBadge: true,
    },
});

Vue.use(SvgVue);

/**
 * Recursively register all Vue components in JS folder
 */

const files = require.context('./', true, /\.vue$/i);
files.keys().map((key) => Vue.component(key.split('/').pop().split('.')[0], files(key).default));

/**
 * Create Vue application instance
 */

import { i18n } from '@localization';

const app = new Vue({
    el: '#base',

    i18n,

    data: {
        navigationIsVisble: false,
        stickyNavigation: false,
        trainingEnrollmentVisible: false,
        trainingEnrollmentId: null,
        videoModalVisible: false,
        isMobile: false,
        isResizing: false,
        resizingTimeout: null,
    },

    mounted() {
        this.init();
        const self = this;

        this.$nextTick(function () {
            // Smooth scroll to current hash
            if (windowhash) {
                if (windowhash == '#wordlid') {
                    self.showMemberShipModal();
                } else {
                    window.setTimeout(function () {
                        scrollToPossibleHash(windowhash);
                    }, 500);
                }
            }

            // Enable smooth scrolling on anchor links in page
            var hashlinks = document.querySelectorAll("a[href*='#']:not([href='#'])");

            for (var i = 0; i < hashlinks.length; i++) {
                hashlinks[i].addEventListener('click', function (e) {
                    if (location.href.replace(location.hash, '') === e.target.href.split('#')[0]) {
                        e.preventDefault();
                        if (this.hash == '#wordlid') {
                            self.showMemberShipModal();
                        } else {
                            console.log(e.target.href);
                            scrollToPossibleHash(this.hash);
                        }
                    }
                });
            }

            resizeMe(resizeElements);

            Tally.loadEmbeds();
        });

        window.addEventListener('resize', () => {
            self.init();
            self.resizing();
            resizeMe(resizeElements);
        });

        window.addEventListener('orientationchange', () => {
            self.init();
            self.resizing();
        });

        let last_known_scroll_position = 0;
        let ticking = false;
        window.addEventListener('scroll', function (e) {
            last_known_scroll_position = window.pageYOffset;
            if (!ticking) {
                window.requestAnimationFrame(function () {
                    if (last_known_scroll_position > 0) {
                        self.stickyNavigation = true;
                    } else {
                        self.stickyNavigation = false;
                    }
                    ticking = false;
                });

                ticking = true;
            }
        });

        cssVars();
    },

    methods: {
        init() {
            let vh = window.innerHeight * 0.01;
            document.documentElement.style.setProperty('--vh', `${vh}px`);
            this.isMobile = window.innerWidth < 767.98;
        },
        resizing() {
            this.isResizing = true;
            window.clearTimeout(this.resizingTimeout);
            this.resizingTimeout = window.setTimeout(() => {
                this.isResizing = false;
            }, 500);
        },

        showMemberShipModal() {
            this.$modal.show('become-member-modal', null, { width: '996', height: 'auto', scrollable: true });
        },
    },

    watch: {
        navigationIsVisble: function () {
            document.getElementsByTagName('body')[0].classList.toggle('navigation-active');
        },
        trainingEnrollmentVisible: function () {
            document.getElementsByTagName('body')[0].classList.toggle('enrollment-modal-active');
        },
        videoModalVisible: function () {
            document.getElementsByTagName('body')[0].classList.toggle('video-modal-active');
        },
        isResizing: function () {
            document.getElementsByTagName('body')[0].classList.toggle('resizing');
        },
        stickyNavigation: function () {
            const header = document.getElementsByTagName('header')[0];
            header.classList.toggle('fixed');

            if (header.classList.contains('fixed')) {
                document.querySelector('div.base').style.paddingTop = header.offsetHeight + 'px';
            } else {
                document.querySelector('div.base').style.paddingTop = 0;
            }
        },
    },
});
